// extracted by mini-css-extract-plugin
export var checkbox = "_99-0";
export var circle = "_99-3";
export var horizontalContainer = "_99-7";
export var sm = "_99-5";
export var switch0 = "_99-2";
export var switchDisabled = "_99-8";
export var switchEnabled = "_99-1";
export var textSwitchContainer = "_99-9";
export var textSwitchOption = "_99-a";
export var textSwitchOptionSelected = "_99-b";
export var verticalContainer = "_99-6";
export var xs = "_99-4";